import React, {createContext, useContext, useState, useEffect} from 'react'
import axios from 'axios'

import {Icon} from '@salesforce/design-system-react';

import {AppContext} from './appContext'

const MappingsContext = createContext()

function MappingsContextProvider({children}) {
  const [pluginObjectId, setPluginObjectId] = useState('')
  const [pluginObjectName, setPluginObjectName] = useState('')
  const [availableSalesforceObjects, setAvailableSalesforceObjects] = useState([])
  const [selectedSalesforceObjects, setSelectedSalesforceObjects] = useState([])

  const {jwt} = useContext(AppContext)
  
  useEffect(() => {
    // return if pluginObjectId invalid
    if (pluginObjectId === '' || pluginObjectId <= 0 ) { return }
    const fetchMappings = async () => {
      try {
        const result = await axios({
          method: 'get',
          url: '/api/salesforce_objects',
          params: {
            jwt: jwt
          }
        })
        setAvailableSalesforceObjects(result.data.salesforceObjects)
      } catch (error) {
        console.log(error)
      }

      try {
        const result = await axios({
          method: 'get',
          url: `/api/plugin_objects/${pluginObjectId}`,
          params: {
            jwt: jwt
          }
        })
        setPluginObjectId(result.data.id)
        setPluginObjectName(result.data.name)
        // add icons to result
        const salesforceObjectsWithIcon = result.data.salesforceObjects.map((elem) => ({
          ...elem,
          ...{
            icon: (
              <Icon
                assistiveText={{ label: elem.label }}
                category="standard"
                name={elem.iconType}
              />
            ),
          },
        }))
        
        setSelectedSalesforceObjects(salesforceObjectsWithIcon)
      } catch (error) {
        console.log(error)
      }
    }
    fetchMappings()
  }, [pluginObjectId])
  
  const changePluginObjectName = (name) => {
    const updateName = async () => {
       try {
        const result = await axios({
          method: 'patch',
          url: `/api/plugin_objects/${pluginObjectId}`,
          data: {
            jwt: jwt,
            name: name
          }
        })
        console.log(`url: /api/plugin_objects/${pluginObjectId}`) 
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    updateName()
  }

  const addSalesforceObject = (name) => {
    console.log("ADD SALESFORCE OBJECT")
  }

  const removeSalesforceObject = (name) => {
    console.log("REMOVE SALESFORCE OBJECT")
  }

  const addPluginMapping = (objectName) => {
    console.log("ADD PLUGIN MAPPING")
  }

  const removePluginMapping = (id) => {
    console.log("REMOVE PLUGIN MAPPING")
  }

  const updatePluginMapping = (id, salesforceFieldname, hootsuiteFieldname) => {
    console.log("UPDATE PLUGIN MAPPING")
  }  

  return (
    <MappingsContext.Provider value={
      {
        pluginObjectId,
        setPluginObjectId,
        pluginObjectName,
        setPluginObjectName,
        availableSalesforceObjects,
        setAvailableSalesforceObjects,
        selectedSalesforceObjects,
        setSelectedSalesforceObjects,
        changePluginObjectName,
        addSalesforceObject,
        removeSalesforceObject,
        addPluginMapping,
        removePluginMapping,
        updatePluginMapping
      }
    }>
      {children}
    </MappingsContext.Provider>
  )
}

export {MappingsContextProvider, MappingsContext}
